import {
  axiosGetWithCookies,
  axiosGetWithCookiesCancel,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';

export const fetchRegionList = ({
  archived = false,
  search = '',
  from = 0,
}) => {
  let query = `/regions/regions?from=${from}`;
  if (archived) query += `&includeArchived=${archived}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};
export const fetchRegionDetails = id =>
  axiosGetWithCookies(`/regions/regions/${id}`);
export const createRegion = region =>
  axiosPostWithCookies('/regions/regions', {
    data: region,
  });

export const updateRegion = region =>
  axiosPutWithCookies(`/regions/regions/${region.id}`, {
    data: region,
  });
export const fetchZoneList = ({
  regionId,
  archived,
  risk,
  search,
  from,
  fetchAll,
  departmentId,
}) => {
  let query = `/regions/zones?regionId=${regionId}`;
  if (!fetchAll) {
    query += `&limit=50`;
  }
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (archived) query += `&includeArchived=${archived}`;
  if (risk) query += `&risk=${risk}`;
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};
export const fetchZoneDetails = id =>
  axiosGetWithCookies(`/regions/zones/${id}`);
export const createZone = zone =>
  axiosPostWithCookies('/regions/zones', {
    data: zone,
  });
export const updateZone = (id, zone) =>
  axiosPutWithCookies(`/regions/zones/${id}`, {
    data: zone,
  });

// referenced related api - for location
// integration.app.securityrisk.com/api/v1/gateway/regions/regions/{id}/matching-locations

export const fetchAddressList = ({ regionId, search }) => {
  const query = `/regions/regions/${regionId}/matching-locations?query=${search}`;
  return axiosGetWithCookiesCancel(query);
};
